import { render, staticRenderFns } from "./tab-inactive.vue?vue&type=template&id=03f5b92c"
import script from "./tab-inactive.vue?vue&type=script&lang=js"
export * from "./tab-inactive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports